@if (!loading) {
  <div>
    @if (loadAnnoymously()) {
      <router-outlet></router-outlet>
    }
    @if (!loadAnnoymously()) {
      <sb-shell>
        <router-outlet></router-outlet>
      </sb-shell>
      <sb-profile-popup></sb-profile-popup>
    }
    <sb-toast-container></sb-toast-container>
  </div>
}
@if (loading) {
  <div
    class="loading-container">
    <sb-page-loader [noAuth]="true"></sb-page-loader>
  </div>
}
